import { useDispatch, useSelector } from 'react-redux'
import { selectFields, selectGooglePay, selectId as selectPaymentMethodId, setGooglePaySelectedInstallment } from '../app/reducers/paymentMethod'
import { selectList } from '../app/reducers/methodsList'
import Field from "../components/Field";
import PaymentResultAmount from "../components/PaymentResultAmount";
import PaymentResultMethod from "../components/PaymentResultMethod";
import GooglePayInstallmentsView from "../components/GooglePayInstallmentsView";
import WalletUnavailableNotice from "../components/WalletUnavailableNotice";
import { useTranslation } from '../hooks/useTranslation';

export default function PaymentForm({ showResult }){
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const fields = useSelector(selectFields);
  const methodsList = useSelector(selectList);
  const methodId = useSelector(selectPaymentMethodId);
  const googlePay = useSelector(selectGooglePay);

  if(!showResult){
    const gpayStep = googlePay && googlePay.step;

    if (gpayStep === 'unavailable') {
      const selectedMethod = (methodsList || []).find(m => m.id === methodId);
      const providerName = selectedMethod
        ? ('i18nKey' in selectedMethod ? t(selectedMethod.i18nKey) : selectedMethod.name)
        : '';
      const iconUrl = selectedMethod ? selectedMethod.small_icon_monochrome : undefined;
      return (<WalletUnavailableNotice providerName={providerName} iconUrl={iconUrl} />);
    }

    if (gpayStep === 'loading' || gpayStep === 'installments') {
      return (
        <div className={"gpay-flow-content"+(gpayStep === 'installments' ? " fade-visible" : " fade-loading")}>
          {gpayStep === 'loading' ? (
            <div className="gpay-installments-loading" role="status" aria-live="polite">
              <div className="spinner-small" />
              {(() => {
                const key = 'payment_method.gpay_loading_installments';
                const label = t(key);
                return label && label !== key
                  ? <div className="gpay-installments-loading-label">{label}</div>
                  : null;
              })()}
            </div>
          ) : (
            <GooglePayInstallmentsView
              cardNetwork={googlePay.cardInfo && googlePay.cardInfo.cardNetwork}
              cardLast4={googlePay.cardInfo && googlePay.cardInfo.cardDetails}
              installments={googlePay.installments}
              i18n={googlePay.i18n}
              selected={googlePay.selectedInstallment}
              onSelect={(opt) => dispatch(setGooglePaySelectedInstallment(opt))}
            />
          )}
        </div>
      );
    }
    return (
      <>
        {fields.map((value,pos) => <Field key={value.random_key} {...value} />)}
      </>
    );
  }

  const hasClass = (f, cls) => typeof f.className === "string" && f.className.split(/\s+/).includes(cls);
  const isTitle = (f) => f.type === "paragraph-field" && hasClass(f, "payment-result-title-field");
  const isDescription = (f) => f.type === "paragraph-field" && !hasClass(f, "payment-result-title-field");
  const isImage = (f) => f.type === "main-image-field";

  const list = fields || [];
  const hasTitle = list.some(isTitle);
  const nodes = [];
  let amountInserted = false;

  list.forEach((value) => {
    if(isImage(value)){
      nodes.push(<Field key={value.random_key} {...value} className="payment-result-image-field" />);
    }else if(isTitle(value)){
      nodes.push(<Field key={value.random_key} {...value} />);
      nodes.push(<PaymentResultAmount key="payment-result-amount" />);
      amountInserted = true;
    }else if(isDescription(value)){
      nodes.push(<Field key={value.random_key} {...value} />);
    }else{
      nodes.push(<Field key={value.random_key} {...value} />);
    }
  });

  if(!hasTitle && !amountInserted){
    nodes.push(<PaymentResultAmount key="payment-result-amount" />);
  }

  if(methodsList.length === 1){
    nodes.push(<PaymentResultMethod key="payment-result-method" />);
  }

  return (<>{nodes}</>);
}
